import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getProductToReorderList} from './actions';
import {bindActionCreators} from "redux";
import {Report} from "../utils/report";
import {Divider, InputNumber} from "antd";

function suggestedQuantity(record) {
  return (((record.quantitySold / record.overPeriodInDays) * record.daysToReorder) + 0.49).toFixed();
}

const defaultPrint = x => x || '-';

const columns = [
  {
    title: 'Supplier',
    dataIndex: 'supplierName',
    key: 'supplierName',
    print: defaultPrint
  },
  {
    title: 'Product',
    dataIndex: 'productDisplay',
    key: 'productDisplay',
    print: defaultPrint
  },
  {
    title: 'Quantity in Stock',
    dataIndex: 'quantityInStock',
    key: 'quantityInStock',
    print: defaultPrint
  },
  {
    title: 'Quantity Sold',
    dataIndex: 'quantitySold',
    key: 'quantitySold',
    print: defaultPrint
  },
  {
    title: 'Over Period',
    dataIndex: 'overPeriodInDays',
    key: 'overPeriodInDays',
    render: value => <span>{value} day(s)</span>,
    print: defaultPrint
  },
  {
    title: 'Suggested Quantity',
    dataIndex: 'daysToReorder',
    key: 'suggestedQty',
    render: (_, record) => <span>{suggestedQuantity(record)}</span>,
    print: (_, record) => suggestedQuantity(record)
  },
  {
    title: 'Suggested Quantity to Order',
    dataIndex: 'daysToReorder',
    key: 'toOrder',
    render: (_, record) => <span>{suggestedQuantity(record) - record.quantityInStock}</span>,
    print: (_, record) => (suggestedQuantity(record) - record.quantityInStock)
  }
];

class ProductToReorderListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      daysToReorder: 14,
      transformData: this.dataTransformer(14),
    };
  }

  dataTransformer(daysToReorder) {
    return data => {
      return data.map(x => ({...x, daysToReorder}))
        .filter(p => suggestedQuantity(p) > p.quantityInStock);
    };
  }

  onDaysToReorderChange = daysToReorder => {
    this.setState({daysToReorder, transformData: this.dataTransformer(daysToReorder)});
  };

  render() {
    return <div>
      Reorder for&nbsp;
      <InputNumber value={this.state.daysToReorder}
                   onChange={this.onDaysToReorderChange} />
      &nbsp;days
      <Divider type="horizontal" />
      <Report title="Inventory Products to Reorder"
              readModelName="productToReorderList"
              rowKey="productId"
              columns={columns}
              filterProvider={() => ({
                where: {
                  dispensaryId: {eq: this.props.dispensaryId},
                  productVisibleOnTill: {eq: true},
                },
                order: 'name ASC'
              })}
              transformData={this.state.transformData}
              printHeader={`Reorder for ${this.state.daysToReorder} days`} />;
    </div>;
  }
}

ProductToReorderListPage.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  productToReorderList: PropTypes.array.isRequired,
  getProductToReorderList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  productToReorderList: state.product.productToReorderList,
});

const mapDispatchToProps = dispatch => ({
  getProductToReorderList: bindActionCreators(getProductToReorderList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductToReorderListPage);



// WEBPACK FOOTER //
// ./src/Product/ProductToReorderReport.js